module.exports = __webpack_public_path__ + "media/24.74b7c03b.mp4";